import { compose } from 'redux';
import { connect } from 'react-redux';
import { narrateReset } from '../../../../common/audio/audioActions';
import MultiChoiceQuestionView from '../../../../common/questions/multiChoiceQuestionView';
import * as multiChoiceUtils from '../../../../common/questions/multiChoiceQuestionUtils';
import { resetQuestionsAndTimeTrackingState } from '../../../../common/questions/questionsActions';
import { Size } from '../../../../constants/components';
import { RCT, ACCURACY } from '../../../../constants/measure';
import { SHORT_WORD_LENGTH } from '../../../../constants/text';
import { goToInterstitial, goToQuestion } from '../../../../common/navigation/navigationActions';
import { setPlaylistItemCompleted } from '../../../../common/playlist/playlistActions';
import { deactivateNextButton, blockScreen, unblockScreen } from '../../../../common/screen/screenActions';
import { getQuestionIndex } from '../../../../common/utils/urlParsers';
import { QUESTIONS } from '../../../../constants/assessmentItemType';
import { fetchRctAccuracyContent, saveAccuracyResponse } from '../../../rctActions';
import selectors from '../../../../rootSelectors';
import RCT_AUDIO_INSTRUCTIONS from '../../../rctConstants';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { startQuestionTimeTracking, stopQuestionTimeTracking } from '../../../../common/timeTracking/timeTrackingActions';

const ACCURACY_AUDIO = RCT_AUDIO_INSTRUCTIONS.ACCURACY;

const mapStateToProps = (state, ownProps) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        pageLayout: `${RCT}-${ACCURACY}`,
        isDataFetched: selectors.getIsRCTAccuracyDataFetched(state),
        fontSize: selectors.getRctAccuracyMaxResponseLength(state, QUESTIONS) > SHORT_WORD_LENGTH
            ? Size.SMALL : Size.LARGE,
        possibleResponses: selectors.getRCTAccuracyPossibleResponses(
            state, QUESTIONS, questionIndex - 1,
        ),
        stimulusAudio: selectors.getRCTAccuracyStimulusAudio(state, QUESTIONS, questionIndex - 1),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    return {
        ...props,
        onNext: () => {
            const questionIndex = getQuestionIndex(ownProps.match.params);
            dispatch(blockScreen());
            dispatch(stopQuestionTimeTracking());
            dispatch(saveAccuracyResponse(questionIndex))
                .then((isComplete) => {
                    dispatch(unblockScreen());
                    if (isComplete) {
                        dispatch(setPlaylistItemCompleted(ACCURACY));
                        dispatch(goToInterstitial());
                    } else {
                        dispatch(goToQuestion(RCT, ACCURACY, questionIndex + 1));
                        dispatch(narrateReset());
                        dispatch(deactivateNextButton());
                        dispatch(resetQuestionsAndTimeTrackingState());
                    }
                });
        },
        fetchContent: () => dispatch(fetchRctAccuracyContent()).then(() => dispatch(startQuestionTimeTracking())),
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
    instructions: ACCURACY_AUDIO.accuracyQuestionsInstruction,
});

const RCTAccuracyQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MultiChoiceQuestionView);

export default RCTAccuracyQuestionsContainer;
